// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-074fe9f6]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.container[data-v-074fe9f6] {\n  padding: 30px;\n  display: flex;\n  justify-content: center;\n}\n.button-container[data-v-074fe9f6] {\n  text-align: left;\n  margin: 1em auto;\n}\n.link[data-v-074fe9f6] {\n  text-decoration: underline;\n  color: #1890ff;\n}", ""]);
// Exports
module.exports = exports;
